import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { SABER_BLUE, SABER_GREEN } from '../constants';

interface Star {
  x: number;
  y: number;
  size: number;
  delay: number;
  dur: number;
}

export function StarFieldBg() {
  const [stars, setStars] = useState<Star[]>([]);

  useEffect(() => {
    const s: Star[] = [];
    for (let i = 0; i < 120; i += 1) {
      s.push({
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: 0.5 + Math.random() * 1.5,
        delay: Math.random() * 8,
        dur: 3 + Math.random() * 5,
      });
    }
    setStars(s);
  }, []);

  return (
    <div className='pointer-events-none fixed inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      {stars.map((star, i) => (
        <motion.div key={i} className='absolute rounded-full' style={{ left: `${star.x}%`, top: `${star.y}%`, width: star.size, height: star.size, background: 'white' }} animate={{ opacity: [0.1, 0.7, 0.1] }} transition={{ duration: star.dur, delay: star.delay, repeat: Infinity, ease: 'easeInOut' as const }} />
      ))}
      <div className='absolute end-[12%] top-[15%] size-48 rounded-full opacity-[0.07]' style={{ background: `radial-gradient(circle, ${SABER_BLUE}, transparent)`, filter: 'blur(40px)' }} />
      <div className='absolute bottom-[20%] start-[8%] size-40 rounded-full opacity-[0.06]' style={{ background: `radial-gradient(circle, ${SABER_GREEN}, transparent)`, filter: 'blur(35px)' }} />
    </div>
  );
}
